import React, {useState} from 'react'
import { useHistory } from 'react-router-dom';
import { auth } from './include/Authorize'
import './Login.css'
import {useStateValue} from '../../utils/Provider/StateProvider'

function Login() {
  const history = useHistory();
  const [{ user }, dispatch] = useStateValue();

  const [account, displayAccount] = useState(true);
  
  const [email, setEmail ] = useState('');
  const [name, setName ] = useState('');
  const [password, setPassword] = useState('');

  // Sign-in User
  const signin = e => {
    e.preventDefault();

    auth
        .signInWithEmailAndPassword(email, password)
        .then(auth => {
            history.push('/')
        })
        .catch(err =>
            dispatch({
                type: 'ERROR',
                message: err.message
            })
        )

  }

  // Create new User Account:
  const registerNewUser = e => {
    e.preventDefault();

    auth.createUserWithEmailAndPassword(email, password)

        .then((auth) => {
            console.log(auth);

            history.push('/')

            if (auth) {
                return auth.user.updateProfile({
                    displayName: name
                })
                
            }


        })
        .catch(error =>
            dispatch({
                type: 'ERROR',
                message: error.message
            })
        )

    // Switch display:
    displayAccount(true)

}


  return (
    <div>
      {account ? 

        <div className='login_div_container'>
            <h3>Login to your Account</h3>
            <hr/>
            <p className='login_desc'>Welcome to <span>FamilyPlot</span></p>
          
            <label for='email_inp'>Email:</label><br />
            <input type='text' placeholder='Email' id='email_inp' className='email_inp' value={email} onChange={e => setEmail(e.target.value)} /><br />

            <label for='password_inp'>Password:</label><br />
            <input type='password' placeholder='password' id='password_inp' className='password_inp' value={password} onChange={e => setPassword(e.target.value)} /><br />


            <p className='login_signin_msg'>
                By Sign-In you agree Terms and conditions
            </p>

            <button type='submit' className='login_button' onClick={signin}>Login</button>

            <button type='submit' className='createAccount_button' onClick={() => displayAccount(false)}>Create Account</button><br/>
            

        </div>
      :
        <div className='login_div_container'>
            <h3>Create your Account</h3>
            <hr/>
            <p className='login_desc'>Welcome to <span>FamilyPlot</span></p>

            <label for='user_inp'>User Name:</label><br />
            <input type='text' placeholder='User Name' id='user_inp' className='name_inp' value={name} onChange={e => setName(e.target.value)} /><br />

            <label for='email_inp'>Email:</label><br />
            <input type='text' placeholder='Email' id='email_inp' className='email_inp' value={email} onChange={e => setEmail(e.target.value)} /><br />

            <label for='password_inp'>Password:</label><br />
            <input type='password' placeholder='password' id='password_inp' className='password_inp' value={password} onChange={e => setPassword(e.target.value)} /><br />


            <p className='login_signin_msg'>
                By Creating this Account you accept the Terms and conditions
            </p>

            <button type='submit' style={{backgroundColor:'crimson', color:'white'}} className='createAccount_button' onClick={registerNewUser}>Create Account</button>

        </div>
      
      }
    </div>
  )
}

export default Login